import React from "react";

const Heading = ({ children }) => {
  return <h1 className="text-lg">{children}</h1>;
};

export default Heading;
